<p>compass-add works!</p>
